<template lang="pug">
  dv-card.pa-6(
    flat
    color="ui-background"
    class="rounded-16"
    :outlined="false"
  )
    dv-form(
      v-model="formData"
      :schema="schema"
      :nestable="false"
      v-slot="{ fields }"
    )
      v-row
        v-col(
          cols="12"
          xl="8"
          lg="8"
          md="6"
        )
          dv-form-field(
            :field="fields.name"
          )
        v-col(
          cols="12"
          xl="4"
          lg="4"
          md="6"
        )
          dv-form-field(
            :field="fields.maxScore"
          )
      v-row
        v-col(cols="12")
          dv-form-field(
            :field="fields.description"
          )

    v-row(
      v-if="!hideActions"
    )
      v-col(cols="12")
        dv-btn.my-3(
          large
          text
          @click="() => $emit('delete')"
        )
          v-icon.mr-2(size="20" color="ui-error") $ui-delete
          p.ui-error--text Удалить критерий
</template>

<script>
import DvCard from '@/packages/ui/components/cards/DvCard.vue';
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import DvNumberField from '@/packages/ui/components/inputs/DvNumberField.vue';
import DvTextarea from '@/packages/ui/components/inputs/DvTextarea.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  components: {
    DvCard,
    DvForm,
    DvFormField,
    DvBtn,
  },
  props: {
    hideActions: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
      schema: [
        {
          name: 'name',
          value: 'name',
          rules: 'required_fill',
          label: 'Название',
          component: DvTextField,
        },
        {
          name: 'maxScore',
          value: 'max_score',
          rules: 'required_fill',
          label: 'Макс. баллов',
          component: DvNumberField,
          props: {
            min: 0,
            max: 999,
          },
        },
        {
          name: 'description',
          value: 'description',
          label: 'Дополнительная информация',
          component: DvTextarea,
        },
      ],
    };
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
};
</script>
